import React from 'react';
import {Box, Icon, Stack, Text, Image, Slider, HStack} from "@chakra-ui/react";
import {LuBed, LuGrid2X2} from "react-icons/lu";

const SavingsCard = ({numBedrooms, numPanels, minAnnualSavings, maxAnnualSavings, imgSrc}) => {
    return (
        <Box bg="white" color="black" borderRadius="md" p={4} shadow="md">
            <Stack direction={{base: "column", md: "row"}}>
                <Box width={{base: "100%", md: "40%"}}>
                    <Image
                        src={imgSrc}
                        objectFit="cover"
                        w="100%"
                        h="100%"
                        borderRadius="md"
                    />
                </Box>
                <Box width={{base: "100%", md: "60%"}} textAlign={"left"} px={5} fontSize={{base: "md !important", md: "lg !important"}}>
                    <HStack mb={3} mt={6}>
                      <Icon as={LuBed} />
                      <Text fontSize={"lg !important"} color={"black !important"}><strong>{numBedrooms}</strong> bedrooms</Text>
                    </HStack>
                    <Box mb={5}>
                        <Icon as={LuGrid2X2} mr={2} />
                        <Text as="span" fontWeight="bold">{numPanels}</Text> panels required
                    </Box>

                    <Slider.Root
                        width="100%"
                        defaultValue={[minAnnualSavings, maxAnnualSavings]}
                        readOnly
                        size={{base: "md", md: "lg"}}
                        colorPalette={"green"}
                        min={0}
                        max={1000}
                        thumbSize={{width: 5, height: 5}}
                    >
                        <Text mt={4} mb={2} fontWeight="semibold" fontSize={{base: "lg !important", md: "xl !important"}} color={"black !important"}>Annual Savings</Text>
                        <Slider.Control>
                            <Slider.Track>
                                <Slider.Range />
                            </Slider.Track>
                            <Slider.Thumb index={0} boxSize={4} bg="green.600">
                                <Text position="absolute" top="15px" fontSize={{base: "xs !important", md: "sm !important"}} color={"black !important"} fontWeight={"bold"}>
                                    €{minAnnualSavings}
                                </Text>
                            </Slider.Thumb>
                            <Slider.Thumb index={1} boxSize={4} bg="green.600">
                                <Text position="absolute" top="15px" fontSize={{base: "xs !important", md: "sm !important"}} color={"black !important"} fontWeight={"bold"}>
                                    €{maxAnnualSavings}
                                </Text>
                            </Slider.Thumb>
                        </Slider.Control>
                    </Slider.Root>
                </Box>
            </Stack>
        </Box>
    );
};

export default SavingsCard;